import { Document, UserProfile } from "../../models"
import { CustomInputMapping, UserCollectionsState } from "../../redux"
import { getCustomInput } from "../customInputMapping"
import { definedRules, factoryArgs, factoryExecuter, Rule } from "./rulesHelpers"

export type CanUserEditOptions = {
    exclude: Rule[]
}
export const defaultCanUserEditOptions: CanUserEditOptions = {exclude: []}

export const canUserEdit = (
    user: UserProfile,
    collections: UserCollectionsState,
    document: Document,
    customInputMappings: CustomInputMapping[]
): boolean => {
    return canUserEditWithOptions(user, collections, document, customInputMappings, {exclude: ['customInputAndEveryoneCanEdit', 'editableTypesForEveryone', 'everyoneCanEditDocument']})
}

export const canUserEditWithOptions = (
    user: UserProfile,
    collections: UserCollectionsState,
    document: Document,
    customInputMappings: CustomInputMapping[],
    options: CanUserEditOptions = defaultCanUserEditOptions
): boolean => {
    const {exclude} = options
    const appliedRules = definedRules.filter(rule => !exclude.includes(rule))
    const customMapping = getCustomInput(document.dataType, customInputMappings)

    if (!exclude.includes('userOrgViewer') && factoryExecuter('userOrgViewer')(user)) {
        return false
    }
    const result = appliedRules.reduce((accum, rule) => {
        const args = factoryArgs(user, collections, document, customMapping)(rule)
        const executer = factoryExecuter(rule)

        return accum || executer(...args)
    }, false)
    return result
}

